import { useTranslation } from 'react-i18next';
import usePageMeta from '@/hooks/usePageMeta';
import HeroSection from '@/pages/home/components/HeroSection';
import IntroSection from '@/pages/home/components/IntroSection';

export default function Home() {
  const { t } = useTranslation();

  usePageMeta({
    title: 'S+N Blech- und Metallverarbeitung | Lauter-Bernsbach',
    description:
      'S+N Blech- und Metallverarbeitungs GmbH aus Lauter-Bernsbach: Zuschnitt, Stanzen, Kanten und Montagearbeiten in Blech und Metall. Seit 2001 zuverlässig.',
    keywords: 'Blechbearbeitung, Metallverarbeitung, Stanzen, Kanten, Zuschnitt, Lauter-Bernsbach',
  });

  return (
    <>
      <HeroSection />
      <IntroSection />
    </>
  );
}